import { createFileRoute } from "@tanstack/react-router";
import { HomePage } from "../../../components/home/home-page";

export const Route = createFileRoute("/_authenticated/_workspace/home")({
  component: WorkspaceHome,
});

function WorkspaceHome() {
  const { session } = Route.useRouteContext();
  const firstName = session.user.name.trim().split(/\s+/)[0] || "there";
  return <HomePage firstName={firstName} />;
}
